import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/crm/sales-order/{id}/ship`。PREPARING → SHIPPING。body：`updatedAt`。 */
export async function shipSalesOrder(id, payload = {}) {
  const { data: raw } = await request.post(
    `/crm/sales-order/${id}/ship`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
